import { ZodiacSagittariusIcon } from './ZodiacSagittariusIcon';

/**
 * author: Michael Richins
 * id 1FC91C87-E02C-4830-B0A6-6EA7CDABB8D3
 * name zodiac-sagittarius
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-sagittarius.svg
 * tags
 */
export const HoroscopeSagittariusIcon = ZodiacSagittariusIcon;
export default HoroscopeSagittariusIcon